import { axiosInstance, requestConfig } from 'network/apis';

import { URL_BILLING } from "utils/constants";

export const callShopBillReceiveInfo = async () => {
    return await axiosInstance(requestConfig('get', URL_BILLING, '/shop-payment/bill-receive'));
};